import { useEffect } from 'react';

import { Icon } from '../Icon/Icon';

import { LeftBlock, Root, Text } from './SnackBar.ui';

const TIMEOUT_AUTO_CLOSE_SNACKBAR = 3000;

export const SnackBar = ({
  title,
  onClose,
  open,
}: {
  title: string;
  onClose: VoidFunction;
  open: boolean;
}) => {
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    if (open) {
      timeoutId = setTimeout(onClose, TIMEOUT_AUTO_CLOSE_SNACKBAR);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <Root>
      <LeftBlock>
        <Icon name="error" />
        <Text>{title}</Text>
      </LeftBlock>
      <Icon name="cross" onClick={onClose} />
    </Root>
  );
};
